export default class ReviewStarRating {
  constructor() {
    if (ReviewStarRating.exists) {
      return ReviewStarRating.instance;
    }

    ReviewStarRating.instance = this;
    ReviewStarRating.exists = true;

    this.rating = document.querySelector('#rating');
    this.respond = document.querySelector('#respond');
    this.indicators = [];

    this.attachHandlers();
  }

  attachHandlers() {
    this.initStars();
    this.addEvent();
  }

  initStars() {
    let p = document.createElement("p");
    let html = `
        <span>
            <a class="star-rating-1" data-rating="1" href="#"><span class="sr-only">1</span></a>
            <a class="star-rating-2" data-rating="2" href="#"><span class="sr-only">2</span></a>
            <a class="star-rating-3" data-rating="3" href="#"><span class="sr-only">3</span></a>
            <a class="star-rating-4" data-rating="4" href="#"><span class="sr-only">4</span></a>
            <a class="star-rating-5" data-rating="5" href="#"><span class="sr-only">5</span></a>
        </span>
    `;
    p.classList.add('stars', 'mb-0');
    p.innerHTML = html;

    this.rating.before(p);
  }

  addEvent() {
    let stars = this.respond.querySelectorAll('p.stars a');
    stars.forEach(star => {
      star.addEventListener('click', this.starRatingChange.bind(this));
      star.addEventListener('click', this.starRatingActive.bind(this));
      star.addEventListener('mouseenter', this.starRatingHover.bind(this));
      star.addEventListener('mouseleave', this.starRatingHover.bind(this));
    });
  }

  starRatingChange(event) {
    event.preventDefault();
    let starEl = event.target;
    let rating = starEl.dataset.rating;

    if (!rating) {
      return
    }

    ReviewStarRating.triggerSelectRating(rating);
  }

  starRatingActive( event ) {
    let starEl = event.target;
    let container = starEl.closest('.stars');

    [...starEl.parentElement.children].forEach( el => {
      el.classList.remove('active');
    });
    starEl.classList.add('active');
    container.classList.add('selected');
  }

  starRatingHover(event) {
    const action = event.type === 'mouseenter' ? 'add' : 'remove';
    let starEl = event.target;

    if (!starEl || !starEl.classList || typeof starEl.classList[action] !== "function") {
      return;
    }

    let prev = starEl.previousElementSibling;
    let rating = starEl.dataset.rating;

    starEl.classList[action]('hover');

    this.indicators.forEach((item, index) => {
      if ('mouseleave' === event.type) {
        item.classList.remove('selected');
      } else {
        if (rating && index === parseInt(rating) - 1) {
          item.classList.add('selected')
        } else {
          item.classList.remove('selected')
        }
      }
    });

    while (prev) {
      prev.classList[action]('hover');
      prev = prev.previousElementSibling;
    }
  }

  static triggerSelectRating(selector) {
    let select = document.querySelector('select[name="rating"]');
    if (!select) {
      return
    }

    select.value = selector
    select.dispatchEvent(new Event('change', {bubbles: true}))
  }
}
